export class GetDepartmentDropdownList {
  static readonly type = '[Department] DepartmentDropdownList';
  constructor(
    public dropdownList: any,
    public selectedDepartmentIDList: number[],
  ) {}
}
